<template>
	<ul class="news-list" infinite-scroll-immediate="false" v-infinite-scroll="getUserMessage" style="overflow:auto">
		<li v-for="(item,index) in list" :key="item.order_id+index">
			<div class="order-stauts">{{item.status_str}}</div>
			<div class="order-content">
				<div class="order-number">订单号:{{item.order_sn}}</div>
				<div class="order-goods" v-for="(el,idx) in item.goodslist" :key="el.goods_name+idx">
					<div class="order-goods_left">
						<img :src="el.goods_image" class="order-goods-img">
					</div>
					<div class="order-goods_right">
						<div class="goods-name">{{el.goods_name}}</div>
						<div class="goods-customer">来自:{{item.consignee}}</div>
					</div>
				</div>
				<div class="check-order">
					<div class="check-btn" @click="checkOrder(item.order_id)">发送核对</div>
				</div>
			</div>
		</li>
	</ul>
</template>

<script>
	export default {
		name: 'News',
		data() {
			return {
				list: [], //消息数组
				page: 0, //分页参数
			}
		},
		props: {
			User_code: String,
			status: Number,
			friend_id: Number, //聊天对象id
			msgkey: String,
			store_id: Number,
		},
		methods: {
			async getUserMessage() {
				console.log({
					kf_id: parseInt(this.User_code),
					type: this.status,
					page: this.page,
					is_pc: 1, // 1是pc 2不是
					user_id: this.friend_id,
					msgkey:this.msgkey,
					
				})
				let res = await this.$axios.post('/message/showUserMessage', {
					kf_id: parseInt(this.User_code),
					type: this.status,
					page: this.page,
					is_pc: 1, // 1是pc 2不是
					user_id: this.friend_id,
					store_id:this.store_id,
				})
				if (!res.data.done) {
					this.$message.error(res.data.msg)
					return
				}
				res.data.data.map((item, index) => {
					item.status_str = this.statusHandler(item.status)
					item.goodslist.map((el, idx) => {
						el.goods_image = this.getAvitor(el.goods_image)
					})
				})
				this.page++
				this.list = this.list.concat(res.data.data)
			},
			getAvitor(portrait) {
				var now_avitor;
				if (portrait == null || portrait == "null" || portrait == "") {
					now_avitor = '../image/default-goods.png'
				} else if (portrait != null || portrait != "null") {
					if (portrait.substr(0, 8).toLowerCase() == "https://" || portrait.substr(0, 7)
						.toLowerCase() == "http://") {
						now_avitor = portrait;
					} else {
						now_avitor = 'https://tp.tjztct.com/' + portrait;
					}
				}
				return now_avitor;
			},
			checkOrder(order_id) {
				var bild = '{"type":"say","loginType":"pc","chat_type":"2","onlineType":"pc","fromid":"' + this
					.User_code + '","toid":"' + this.friend_id + '","msgtype":"4","data":"' + order_id +
					'","msgkey":"' + this.msgkey + '","store_id":"' + this.store_id + '"}';
				if(!this.friend_id||!this.msgkey){
					this.$message.warning('请选择聊天对象')
					return
				}
				if(!order_id){
					this.$message.warning('没有指定订单')
					return
				}
				if(!this.store_id){
					this.$message.warning('没有所属店铺')
					return
				}
				console.log(bild)
				this.$http.send(bild)
			},
			// 处理状态
			statusHandler(status) {
				status = Number(status)
				switch (status) {
					case 0:
						return '已结束'
						break;
					case 11:
						return '待付款'
						break;
					case 20:
						return '待发货'
						return
						break;
					case 30:
						return '已发货'
						break;
					case 40:
						return '已完成'
						break;
				}
			},
		},
		created() {}
	}
</script>

<style scoped="scoped">
	.news-list {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
		list-style: none;
		padding: 20px 9px;
	}

	.order-stauts {
		color: #333;
		font-size: 16px;
		margin-bottom: 0.5rem;
		margin-top: 20px;
	}

	.order-content {
		width: 100%;
		background-color: #fff;
		border-radius: 10px;
		color: #666666;
		padding: 0 16px;
		box-sizing: border-box;
		font-size: 16px;
	}

	.order-number {
		height: 44px;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		border-bottom: 1px solid #f5f5f5;
	}

	.order-goods {
		display: flex;
		width: 100%;
		height: 108px;
		width: 100%;
		background-color: #fff;
		box-sizing: border-box;
		padding: 12px 0;
		justify-content: space-between;
	}

	.order-goods_left {
		width: 90px;
		height: 90px;
		border-radius: 10px;
	}

	.order-goods_right {
		width: calc(100% - 104px);
		display: flex;
		flex-wrap: wrap;
		height: 90px;
	}

	.order-goods_right .goods-name {
		margin-bottom: 20px;
		width: 100%;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		font-size: 16px;
		color: #333;
	}

	.order-goods_right .goods-customer {
		font-size: 16px;
		color: #888;
	}

	.order-goods_left img {
		width: 100%;
		height: 100%;
	}

	.check-order {
		width: 100%;
		height: 40px;
		display: flex;
		align-items: center;
		border-top: 1px solid #f5f5f5;
	}

	.check-order .check-btn {
		width: 69px;
		height: 22px;
		display: flex;
		justify-content: center;
		align-items: center;
		border: solid 1px #5792fa;
		color: #5792fa;
		font-size: 12px;
		cursor: pointer;
	}
</style>
